module.exports = {
    title: "Staff",
    crud: {
        create: "Create Staff",
        edit: "Edit Staff",
        view: "View Staff",
    },
    table: {
        username: "Username",
        name: "Name",
        email: "Email",
        mobileNumber: "MobileNumber",
        city: "City",
        state: "State",
        country: "Country",
        type: "Type",
        role: "Role",
    },
    form: {
        username: "Username",
        instituteName:"Institute Name",
        password: 'Password',
        name: "Name",
        summary:"Summary",
        gst:"GST",
        email: "Email",
        mobileNumber: "MobileNumber",
        city: "City",
        state: "State",
        type: "Type",
        country: "Country",
        address1: "Location",
        type: "Type",
        role: "Role",
        timezone: "Timezone",
        startTime: "Start Time",
        endTime: "End Time",
        educationemail:"Education Email",
        licence:"Licence",
        website:"Website",
        adminemail:"Email",
        reflink:"Reference Link",
        adminName:"Name"
    },
    validation: {
        required: {
            address1: 'Location is required',
            mobileNumber: 'Mobile number is required',
            country: 'Country is required',
            state: 'State is required',
            city: 'City is required',
            password: 'Password is required',
            educationemail: 'Email is required',
            adminemail: 'Email is required',
            instituteName: 'Institute Name is required',
            summary: 'summary is required',
            instituteType: 'Institute Type is required',
            type: 'Type is required',
            gst: 'GST is required',
            licence: 'Licence is required',
            website: 'Website is required',
            reflink: 'Reference link is required',
            designation: 'Designation is required',
            adminName: 'Name is required',
        },
        minLength: {
            name: 'Name must have at least',
            stateCode: 'State code must have at least',
            stateCodeName: 'State code name must have at least',
            currencySymbol: 'Currency symbol must have at least',
            currencyCode: 'Currency code must have at least',
            currencyName: 'Currency name must have at least',
            mobileNumber: 'Mobile number must enter 10 digits.',
        },
        educationemail: {
            email: 'Valid email',
        },
        adminemail: {
            email: 'Valid email',
        },
        maxLength: {
            mobileNumber: 'Mobile number must enter 10 digits.',
        },
        numeric: {
            mobileNumber: 'Mobile number must be digit.',
        },
        common: {
            letter: 'letters.',
        }
    },
}
